// extracted by mini-css-extract-plugin
module.exports = {"taker-assist":"taker-assist","incident-option":"incident-option","text-area_ta":"text-area_ta","reason-body":"reason-body"};